import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/banner2/6-2.png'
import _imports_1 from '../../assets/img/step/step-top.svg'
import _imports_2 from '../../assets/img/step/step-ico.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-37a1fd88"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-37a1fd88><div class=\"banner-center\" data-v-37a1fd88><div class=\"textbox\" data-v-37a1fd88><div class=\"banner-text1\" data-v-37a1fd88>互联场地视频会议系统</div><div class=\"banner-text2\" data-v-37a1fd88>助力建设全国统一大市场，优化市场营商环境</div></div><div data-v-37a1fd88><img src=\"" + _imports_0 + "\" alt=\"\" class=\"banner-img\" data-v-37a1fd88></div></div></div>", 1)
const _hoisted_2 = { class: "box1" }
const _hoisted_3 = { class: "stepbox" }
const _hoisted_4 = { class: "stepitembg" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_6 = { class: "stepitem" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-37a1fd88><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-37a1fd88></div><div class=\"stepindex\" data-v-37a1fd88>1</div><div class=\"stepico\" data-v-37a1fd88><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-37a1fd88></div><div class=\"stepTitle\" data-v-37a1fd88> 阅读接入指南 </div><div class=\"stepText\" data-v-37a1fd88> 预览、下载《远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南》 </div>", 5)
const _hoisted_12 = { style: {"display":"flex","margin-top":"44px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_13 = { class: "stepitembg" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_15 = { class: "stepitem" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"step-top\" data-v-37a1fd88><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-37a1fd88></div><div class=\"stepindex\" data-v-37a1fd88>2</div><div class=\"stepico\" data-v-37a1fd88><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-37a1fd88></div><div class=\"stepTitle\" data-v-37a1fd88> 与跨省远程异地目录服务<br data-v-37a1fd88>组件共同联调测试 </div><div class=\"stepText\" data-v-37a1fd88> 与跨省远程异地目录服务组件共同联调测试相关接口 </div>", 5)
const _hoisted_21 = { style: {"display":"flex","margin-top":"34px","justify-content":"space-evenly","padding":"0 10px"} }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"stepitembg\" data-v-37a1fd88><div class=\"overtop\" data-v-37a1fd88></div><div class=\"stepitem\" data-v-37a1fd88><div class=\"step-top\" data-v-37a1fd88><img src=\"" + _imports_1 + "\" alt=\"\" style=\"width:133px;height:70px;\" data-v-37a1fd88></div><div class=\"stepindex\" data-v-37a1fd88>3</div><div class=\"stepico\" data-v-37a1fd88><img src=\"" + _imports_2 + "\" alt=\"\" style=\"width:32px;height:35px;\" data-v-37a1fd88></div><div class=\"stepTitle\" data-v-37a1fd88> 公开测试承诺 </div><div class=\"stepText\" data-v-37a1fd88> 与跨省远程异地目录服务组件共同联调测试通过后，通过远程异地评标和评标专家库共享目录服务组件自助管理终端，上传并公开测试承诺书和自主测试报告，自助加入场地视频会议系统互联目录 </div></div></div>", 1)

import { reactive, toRefs, ref, onMounted } from 'vue'
import systemCatalog from '../../components/systemCatalog'

import { useRoute } from 'vue-router'
import { useRouter } from "vue-router";
import { getOrgCatalog, getTestScripts, endpointDownload, documentPreview, DownloadTestScripts, downloadWithFilePath } from '../../utils/axios/index.js'
import infoDailog from '../infoDailog.vue'
import mytitle from '../../components/title.vue'
import contactUs from '../../components/contactUs.vue'


import { ElMessage } from 'element-plus'
//打开弹框

export default /*#__PURE__*/_defineComponent({
  __name: 'venueVideoConferencingSystem',
  setup(__props) {

const route = useRoute()
const router = useRouter();
let showContactUs1 = ref(false)
// 预览文档
const Previewzn = (type: any) => {
    // documentPreview({ documentType: type }).then(res => {
    //     window._czc.push(['_trackEvent', '互认CA机构', '预览', 'CA机构接入指南预览'])

    //     window.open(res.data.documentUrl, '_blank');
    // }).catch(res => {
    //      ElMessage.warning('功能开发中，敬请期待！')
    // })
    // ElMessage.warning('功能开发中，敬请期待！')

    window._czc.push(['_trackEvent', '场地视频会议系统', '预览', '场地视频会议系统接入指南预览'])


    window.open('L02远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南_20250605_1600.pdf', '_blank');
}
//跳转视频
const tovideo = () => {
    window.open('https://www.yunpan.com/surl_y9tqAvIvstR', '_blank')
}

// 下载文档
const downzn = (type: any, name: any) => {
    // window._czc.push(['_trackEvent', '互认CA机构', '下载', 'CA机构接入指南下载'])
    // let name2 = ''
    // documentPreview({ documentType: type }).then(res => {
    //     name2 = res.data.documentName


    //     endpointDownload({ documentType: type }).then(res => {
    //         var blob = new Blob([res])
    //         let fname = name2 + '.pdf'; //下载文件的名字
    //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //             window.navigator.msSaveOrOpenBlob(blob, fname);
    //         } else {
    //             let objectUrl = URL.createObjectURL(blob);
    //             let link = document.createElement("a");
    //             link.href = objectUrl;
    //             link.setAttribute("download", fname);
    //             document.body.appendChild(link);
    //             link.click();
    //         }


    //     }).catch(res => {

    //     })

    // }).catch(res => {
    //      ElMessage.warning('功能开发中，敬请期待！')
    // })


    // ElMessage.warning('功能开发中，敬请期待！')

    window._czc.push(['_trackEvent', '场地视频会议系统', '下载', '场地视频会议系统接入指南下载'])


    const a = document.createElement('a')
    a.href = 'L02远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南_20250605_1600.pdf'
    a.download = 'L02远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南_20250605_1600.pdf'
    a.click()

}

//机构名称搜索参数
let caOrgName = ref('')


//列表
let allapplist = ref([])

//查看更多
let btnmore = ref(true)


// 搜索

const getOrgList = () => {
    getOrgCatalog({ caOrgName: caOrgName.value }).then(res => {
        allapplist.value = res.data

        allapplist.value.map(item => {
            item.ishover = false
        })


        applist.value = allapplist.value



        btnmore.value = false


    }).catch(err => {
    })
}

// 查看更多
const showmore = () => {
    applist.value = allapplist.value
    btnmore.value = false
}

onMounted(() => {
    // getOrgList()

})
const openDialog = () => {
    // showRegister.value = true
    // canDownload()

    window._czc.push(['_trackEvent', '互认CA机构', '下载测试脚本', '下载CA机构测试脚本'])


    DownloadTestScripts({ scriptType: 1 }).then(res => {
        if (res.data.testScriptsFile) {
            showRegister.value = true
        } else {
            ElMessage.warning('功能开发中，敬请期待！')
        }
    })


}
//下载文件
const downloadFile = (fileUrl, fileName) => {
    // 创建一个a标签  
    const a = document.createElement('a');
    a.href = fileUrl; // 设置文件URL  
    a.download = fileName; // 设置下载的文件名  

    // 隐藏a标签（可选）  
    a.style.display = 'none';

    // 将a标签添加到body中（一些浏览器要求这样做才能触发下载）  
    document.body.appendChild(a);

    // 模拟点击  
    a.click();

    // 移除a标签（可选）  
    document.body.removeChild(a);
}



//关闭弹框

const confirm = () => {
    showRegister.value = false

}
//下载文件

const canDownload = () => {
    DownloadTestScripts({ scriptType: 1 }).then(res1 => {
        // showpdf(res1.data.testScriptsFile)

        downloadFile(res1.data.testScriptsFile, res1.data.testScriptsName)


        // const url = new URL(res1.data.testScriptsFile)
        // let path = String(url.pathname)
        // downloadWithFilePath({ contentDisposition: 'attachment', filePath: path }).then(res => {

        //     var blob = new Blob([res])
        //     let fname = res1.data.testScriptsName + '.zip'; //下载文件的名字
        //     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //         window.navigator.msSaveOrOpenBlob(blob, fname);
        //     } else {
        //         let objectUrl = URL.createObjectURL(blob);
        //         let link = document.createElement("a");
        //         link.href = objectUrl;
        //         link.setAttribute("download", fname);
        //         document.body.appendChild(link);
        //         link.click();
        //     }

        // }).catch(res => {

        // })

    }).catch(res => {

    })

}
let showRegister = ref(false)
//弹框类型
let registrationType = ref(2)

//跳转交易平台
const tosystemJoin = () => {
    router.push({
        path: '/systemJoin',
        query: {
            bottom: true
        }
    })
}
//跳转互认app
const toApp = () => {
    router.push({
        path: '/appJoin',
        query: {
            bottom: true
        }
    })
}
//查看pdf
const showpdf = (url, type) => {
    if (type == 1) {
        window.open(url, '_blank');
    } else {
        window.open(url, '_self');
    }

}





let applist = ref([])




return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(mytitle, {
        title: "对接实施具体步骤",
        style: {"margin-top":"64px"}
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                class: "btn2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (Previewzn(7)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("预览")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                class: "btn1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (downzn(7, '')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createVNode(contactUs, null, null, 512), [
            [_vShow, _unref(showContactUs1)]
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_button, {
                class: "btn2",
                style: {"width":"356px"},
                onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_isRef(showContactUs1) //@ts-ignore
 ? showContactUs1.value = true : showContactUs1 = true)),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_isRef(showContactUs1) //@ts-ignore
 ? showContactUs1.value = false : showContactUs1 = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("联系我们")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_22
      ])
    ]),
    _createVNode(_unref(systemCatalog), {
      title: "互联场地视频会议系统目录",
      placeholder: "请输入场地视频会议系统名称搜索"
    }),
    _createVNode(infoDailog, {
      showRegister: _unref(showRegister),
      registrationType: _unref(registrationType),
      onConfirm: confirm,
      onCanDownload: canDownload
    }, null, 8, ["showRegister", "registrationType"])
  ]))
}
}

})